var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"tags",staticClass:"item-tags",class:_vm.align},[(_vm.tags && _vm.tags.length > 0)?_vm._l((_vm.tags),function(name,idx){return _c('div',{key:idx,class:("tag-" + idx)},[_c('span',[_vm._v(_vm._s(name))])])}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }